module.exports = __webpack_public_path__ + "static/img/take.cd4fc5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/take.png
// module id = hxgM
// module chunks = 1